<style scoped>
.inline-block {
  display: inline-block;
}

.rounded-border {
  border-radius: 50%;
}

.info-font {
  font-size: 0.65em;
}
.userDetails {
  font-size: 14px;
  color: black;
  /* font-weight: 300; */
}
.infoholder {
  margin-top: 30px;
}
</style>

<template lang="pug">
.container
  .vspace.large
  //- pre {{user}}
  v-row
    v-col(cols='12', sm='12')
      p.title.medium General Details
    v-col(cols='12', sm='12')
      img.responsive-img.rounded-border(
        src='../assets/avatar-placeholder.png',
        height='250',
        width='250'
      )
      h5
        | {{ displayName }}
      p
        | Email: {{ user.email }}
      p
        | Address: {{ defaultAddress(user.defaultshipaddr) }}
      p
        | Phone: {{ user.phoneNumber }}
      br
      br
      button.btn(@click='resetpassword') Reset Password
  //-     .col.s12.m6
  //-         img.responsive-img(v-bind:src='imgSrc', height='250', width='250')
  //- .row
  //-     .col.m3
  //-     .col.s12.m6
  //-         .card-panel
  //-             div
  //-                 .valign-wrapper
  //-                     span
  //-                         i.material-icons info
  //-                     | &nbsp; User Information
  //-                 span.info-font
  //-                     hr(size='0.1')
  //-                     .row.infoholder
  //-                       .col.s12.m4
  //-                         label.userDetails Fullname
  //-                       .col.s12.m4
  //-                         label.userDetails  {{ user.firstName }} {{ user.lastName }}
  //-                     .row
  //-                       .col.s12.m4
  //-                         label.userDetails Email
  //-                       .col.s12.m4
  //-                         label.userDetails  {{ user.email }}
  //-                     .row
  //-                       .col.s12.m4
  //-                         label.userDetails Contact NUmber
  //-                       .col.s12.m4
  //-                         label.userDetails  {{ user.phoneNumber }}

  //-                     button.btn(@click="resetpassword") Reset Password
    //- br
    //- div
    //-     .valign-wrapper
    //-         span
    //-             i.material-icons sentiment_very_satisfied
    //-         | &nbsp; QR Code Incentive
    //-     hr
    //-     .center-align


  .vertical-space-small
</template>
<script>
import axios from 'axios'

export default {
  meta: {
    title: 'My profile',
  },
  data() {
    return {
      imgSrc: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user
    },
    displayName() {
      if (!!this.user.firstName && !!this.user.lastName) {
        return this.user.firstName + ' ' + this.user.lastName
      } else {
        return this.user.displayName
      }
    },
  },
  mounted: function () {
    // axios
    //   .get(`${this.$config.API_URL}/customers/${this.user.uid}/qr-code`)
    //   .then((qrCodeDataUrl) => {
    //     this.imgSrc = qrCodeDataUrl.data
    //   })
  },
  methods: {
    resetpassword() {
      this.$router.push({
        name: 'request-password-reset',
        params: { usernameOrEmail: this.user.email },
      })
    },
    defaultAddress(id) {
      const address = this.$store.getters['customer/getFriendlyAddressById'](id)
      if (address !== undefined) {
        return address.name
      } else {
        return ''
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-customer-profile.vue